(function() {
  if ($) {
    const token = $( 'meta[name="csrf-token"]' ).attr( 'content' );

    $.ajaxSetup( {
      beforeSend: function ( xhr ) {
        xhr.setRequestHeader( 'X-CSRF-Token', token );
      }
    });
  }
})();


// WEBPACK FOOTER //
// ./app/javascript/lib/jquery/csrf-token.js